

















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { createEditor, NotifyObject, NotifyUpdateObject, SemanticNotifyObject } from 'semantic-math-editor';
import { tag as gtag } from "@/components/tag";

@Component
export default class EditorA11y extends Vue {
  readInputSymbols = true;
  ro_editor: any;
  validation: any;
  exampleMenu: HTMLElement | null = null;
  ed: HTMLElement | null = null;
  selectedExampleIndex: number = 0;

  mounted() {
    this.ed = document.getElementById("matharia");

    if(!this.ed) return;

    this.ro_editor = createEditor(this.ed);

    this.exampleMenu = document.getElementById("examples-menu");

    this.selectedExampleIndex = 0;

    const self = this;

    this.ro_editor.addOnUpdate(function(updateInfo: any, confirmation: any) {
      const objects: string[] = updateInfo;
      if (null != confirmation) {
        self.updateConfirmOperationSpeech(confirmation);
      } else if (
        objects.some(
          o =>
            o === NotifyUpdateObject.cursor ||
            o === NotifyUpdateObject.selection
        )
      ) {
        self.updateCursorMoveSpeech();
      }
    });

    this.ro_editor.addOnNotify(function(updateInfo: any) {
      const objects: string[] = updateInfo;
      if (objects.some(o => o === NotifyObject.copy)) {
        self.updateCopySpeech();
      } else if (objects.some(o => o === NotifyObject.inputTree)) {
        self.updateInputSpeech();
      } else if (objects.some(o => o === NotifyObject.nonInputTree)) {
        self.updatePartialSpeech();
      } else if (objects.some(o=> o === SemanticNotifyObject.validation)) {
        self.updateSemanticSpeech();
        self.validate();
      }
    });

    // this.ro_editor.addOnSemanticUpdate(function(updateInfo: any) {
    //   const objects: string[] = updateInfo.objects;
    //   if (objects.some(o => o === MathUpdateObject.validation)) {
    //     self.updateSemanticSpeech();
    //     self.validate();
    //   }
    // });

    const errd = document.getElementById("ma-vk-error-descr");

    if(!errd) return;

    this.validation = 
      this.ro_editor.turnOnDefaultValidation(
      errd,
      {
        noErrorsHtml: "Everything is okay!",
        undefinedStateHtml: "Validation data is outdated",
        descriptionElementProvider: () => {
          var li = document.createElement("li");
          li.setAttribute("role", "listitem");
          return li;
        }
      }
    );

    this.readInputSymbols = true;

    this.updateSymbolsReadingLabel();

    if (this.exampleMenu) {
      this.exampleMenu.onblur = () => {
        if (self.exampleMenu) {
          self.exampleMenu.classList.remove("show");
          self.exampleMenu.setAttribute("aria-hidden", "true");
        }
      };

      this.exampleMenu.addEventListener("keydown", function(e) {
        const key = e.which || e.keyCode;

        let toSetIndex = self.selectedExampleIndex;
        if (key === 38) {
          toSetIndex--;
        }
        if (key === 40) {
          toSetIndex++;
        }

        let element = self.trySelectExampleElement(toSetIndex);

        if (key === 13 && element) {
          (<any>element).click();
          (<any>self.exampleMenu).onblur(null);
        }
      });
    }

    this.initializeList();
  }

  initializeList() {
    const self = this;

    const listItems = document.querySelectorAll('#examples-menu li');
    for (let i = 0; i < listItems.length; i++) {
      const index = i;
      (<any>listItems[i]).onmouseover = () => {
        self.resetListHighlight();
        self.selectedExampleIndex = index;
        listItems[index].classList.add("selected");
      };
    }
  }

  resetListHighlight() {
    const listItems = document.querySelectorAll('li.selected');
    listItems.forEach(li => {
      li.classList.remove("selected");
    });
  }

  setSample(tex: string) {
   

    this.ro_editor.cleanEditorWithoutNotify();
    this.ro_editor.paste(tex);
    this.ro_editor.focus();
    if (this.ed) {
      this.ed.focus();
    }
    this.validate();
    this.updateSemanticSpeech();
    gtag('internalAction','a11','selectSample');
  }

  onSymbolsReadingTogglePress() {
    this.toggleSymbolsReadingValue();
    this.updateSymbolsReadingLabel();
  }

  updateSymbolsReadingLabel() {
    var toUpdate =
      "Press to " +
      (this.readInputSymbols ? "ignore" : "read") +
      " the input symbols reading";

    var button = document.getElementById("symbolsReadingToggle");
    if (button) {
      button.setAttribute("value", toUpdate);
    }
  }

  toggleSymbolsReadingValue() {
    this.readInputSymbols = !this.readInputSymbols;
    this.updateSymbolsReadingValueInEditor(this.readInputSymbols);
  }

  updateSymbolsReadingValueInEditor(value: boolean) {
    this.ro_editor.toggleInputSymbolsReading(value);
  }

  trySelectExampleElement(index: number) {
    this.resetListHighlight();

    let element = document.getElementById("ex" + index);
    if (element && this.exampleMenu) {
      this.exampleMenu.setAttribute("aria-activedescendant", "ex" + index);
      this.selectedExampleIndex = index;

      element.classList.add("selected");
    }

    return element;
  }

  openExamplesMenu() {
    if (this.exampleMenu) {
      this.exampleMenu.classList.add("show");
      this.exampleMenu.setAttribute("aria-hidden", "false");
      this.exampleMenu.focus();

      this.trySelectExampleElement(0);
      const self = this;
      let closer = () => {
        (<any>self.exampleMenu).onblur();
        document.removeEventListener("mouseup", closer);
      };

      document.addEventListener("mouseup", closer, false);

      gtag('internalAction','a11','openSampleMenu');
    }
  }

  validate() {
    this.validation();
    gtag('internalAction','a11','validate');
  }

  updateSemanticSpeech() {
    this.setA11ySpeech(this.ro_editor.getSemanticSpeech());
  }

  updateInputSpeech() {
    this.setA11ySpeech(this.ro_editor.speaker.getInputSpeech());
  }

  updatePartialSpeech() {
    this.setA11ySpeech(this.ro_editor.speaker.getTreeUpdateSpeech());
  }

  updateCursorMoveSpeech() {
    this.setA11ySpeech(this.ro_editor.speaker.getCursorMoveSpeech());
  }

  updateCopySpeech() {
    this.setA11ySpeech(this.ro_editor.speaker.getCopySpeech());
  }

  setA11ySpeech(str: string) {
    if (null != str) {
      this.forceSpeaker(str);
    }
  }

  updateConfirmOperationSpeech(confirmation: any) {
    this.setA11ySpeech(
      this.ro_editor.speaker.getConfirmOperationSpeech(confirmation)
    );
  }

  forceSpeaker(text: string, priority?: string) {
    var el = document.createElement("partial-a11y-clone");
    var id = "speak-" + Date.now();
    el.setAttribute("id", id);
    el.setAttribute("aria-live", priority || "polite");
    el.classList.add("screenreader-only");
    document.body.appendChild(el);

    window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.innerHTML = text;
      }
    }, 50);

    window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        document.body.removeChild(el);
      }
    }, 500);
  }
}
